import React, { useState, useEffect, useRef } from "react";
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  IconButton,
  CircularProgress,
  Modal,
  Box,
  Button,
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import { AddAdmin } from "./addAdmin";
import { EditAdmin } from "./editAdmin";
import { GoSearch } from "react-icons/go";
import { axiosInstance } from "../../axiosInstance";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

const columns = [
  // { id: "username", label: "User Name", minWidth: 100, align: "center" },
  { id: "username", label: "NAME", minWidth: 100, align: "center" },
  { id: "email", label: "EMAIL", minWidth: 170, align: "center" },
  { id: "mobile_no", label: "Mobile Number", minWidth: 170, align: "center" },
  // { id: "admintype", label: "ADMIN TYPE", minWidth: 170, align: "center" },
  // { id: "status", label: "STATUS", minWidth: 170, align: "center" },
  { id: "actions", label: "ACTIONS", minWidth: 100, align: "center" },
];

function createData(username, email, mobile_no, admintype, status) {
  return { username, email, mobile_no, admintype, status };
}

const rows = [
  createData("Venkatesh", "abc@gmail.com"),
  createData("Venkatesh", "abc@gmail.com"),
  createData("Venkatesh", "abc@gmail.com"),
  createData("Venkatesh", "abc@gmail.com"),
  createData("Venkatesh", "abc@gmail.com"),
  createData("Venkatesh", "abc@gmail.com"),
  createData("Venkatesh", "abc@gmail.com"),
  createData("Venkatesh", "abc@gmail.com"),
  createData("Venkatesh", "abc@gmail.com"),
  createData("Venkatesh", "abc@gmail.com"),
  createData("Venkatesh", "abc@gmail.com"),
  createData("Venkatesh", "abc@gmail.com"),
  createData("Venkatesh", "abc@gmail.com"),
];

export function ListAdmin() {
  const [adminList, setAdminList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [selectedAdminId, setSelectedAdminId] = useState(null);
  const [toggleModalOpen, setToggleModalOpen] = useState(false);
  const [toggleTarget, setToggleTarget] = useState(null);
  const [searchQuery, setSearchQuery] = useState("");

  const navigate = useNavigate();

  // const [page, setPage] = useState(0);
  // const [rowsPerPage, setRowsPerPage] = useState(20);
  // const handleChangePage = (event, newPage) => {
  //   setPage(newPage);
  // };

  // const handleChangeRowsPerPage = (event) => {
  //   setRowsPerPage(+event.target.value);
  //   setPage(0);
  // };

  const fetchAdmins = async () => {
    setLoading(true);
    setError("");
    try {
      const res = await axiosInstance.get("/admin/admin-list/");
      console.log("✅ Admin list response:", res.data);
      if (res.data.status === "success") {
        setAdminList(res.data.data || []);
      } else {
        setError("Failed to fetch admin data.");
      }
    } catch (err) {
      console.error("❌ Error fetching admin data:", err);
      setError("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchAdmins();
  }, []);

  const handleDelete = async () => {
    try {
      const res = await axiosInstance.delete(
        `/admin/admin-list/${selectedAdminId}/`
      );
      if (res.data.status === "success") {
        toast.success("Admin deleted successfully");
        fetchAdmins();
      } else {
        toast.error(res.data.message || "Delete failed");
      }
    } catch (err) {
      toast.error("Error deleting admin");
    } finally {
      setDeleteModalOpen(false);
    }
  };

  const handleToggleStatus = async () => {
    try {
      const res = await axiosInstance.patch(
        `/admin/admin-list/${toggleTarget.id}/`,
        {
          is_active: !toggleTarget.is_active,
        }
      );
      if (res.data.status === "success") {
        toast.success("Status updated successfully");
        fetchAdmins();
        setToggleModalOpen(false);
      } else {
        toast.error("Failed to update status");
      }
    } catch (err) {
      toast.error("Error updating status");
    }
  };

  //   const filteredData = adminList.filter((row) =>
  //   row.username?.toLowerCase().includes(searchQuery.toLowerCase())
  // );

  const filteredData = adminList.filter((row) => {
    const query = searchQuery.toLowerCase();
    return (
      row.username?.toLowerCase().includes(query) ||
      row.email?.toLowerCase().includes(query) ||
      row.mobile_no?.toLowerCase().includes(query)
    );
  });

  // save table page size in local to save data on page change
  const [page, setPage] = useState(() => {
    const savedPage = localStorage.getItem("admin_page");
    return savedPage ? Number(savedPage) : 0;
  });

  const [rowsPerPage, setRowsPerPage] = useState(() => {
    const savedRows = localStorage.getItem("admin_rowsPerPage");
    return savedRows ? Number(savedRows) : 20;
  });
  const pageChangedByUser = useRef(false);

  const handleChangePage = (event, newPage) => {
    pageChangedByUser.current = true;
    setPage(newPage);
    localStorage.setItem("admin_page", newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    const value = Number(event.target.value);
    pageChangedByUser.current = true;

    setRowsPerPage(value);
    setPage(0);

    localStorage.setItem("admin_rowsPerPage", value);
    localStorage.setItem("admin_page", 0);
  };

  // Reset page on search and filters

  useEffect(() => {
    if (loading) return;

    // Do NOT reset page on refresh
    if (!pageChangedByUser.current) return;

    const maxPage = Math.max(
      0,
      Math.ceil(filteredData.length / rowsPerPage) - 1
    );

    if (page > maxPage) {
      setPage(0);
      localStorage.setItem("admin_page", 0);
    }
  }, [filteredData.length, rowsPerPage, loading, page]);

  return (
    <>
      <div>
        <div className="admin-top-container">
          <div className="admin-listText">List of Admin</div>
          {/* <div>
            <select
              className="listAdmin-showRecords"
              value={rowsPerPage}
              onChange={handleChangeRowsPerPage}
            >
              <option value={20}>Show No of Records</option>
              <option value={50}>50</option>
              <option value={100}>100</option>
              <option value={500}>500</option>
              <option value={1000}>1000</option>
              <option value={2000}>2000</option>
              <option value={5000}>5000</option>
            </select>
          </div> */}
          <div className="search-container">
            <div className="nav-search ">
              <span className="search-icons">
                <GoSearch />
              </span>
              <input
                type="text"
                placeholder="Search"
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
              />
            </div>
          </div>
          <div className="btnAdd">
            <button onClick={() => navigate("/manage-admin-add")}>
              + Add Admin
            </button>
          </div>
        </div>
        <Paper sx={{ width: "100%", overflow: "hidden" }}>
          <TableContainer sx={{ maxHeight: 440 }} className="Table-container">
            <Table stickyHeader aria-label="sticky table">
              <TableHead>
                <TableRow>
                  {columns.map((column) => (
                    <TableCell
                      key={column.id}
                      align={column.align}
                      style={{ minWidth: column.minWidth }}
                      className="table-header"
                    >
                      {column.label}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {loading ? (
                  <TableRow>
                    <TableCell colSpan={columns.length} align="center">
                      <CircularProgress />
                    </TableCell>
                  </TableRow>
                ) : filteredData.length > 0 ? (
                  filteredData
                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    .map((row, index) => (
                      <TableRow
                        className="table-row"
                        hover
                        role="checkbox"
                        tabIndex={-1}
                        key={index}
                        sx={{
                          backgroundColor:
                            index % 2 === 1 ? "#E7F0F9" : "white",
                        }}
                      >
                        {columns.map((column) => {
                          const value = row[column.id];
                          return (
                            <TableCell
                              key={column.id}
                              align={column.align}
                              className={`${column.id}-column tableCelldata`}
                              sx={{
                                color:
                                  column.id === "status"
                                    ? value === "Active"
                                      ? "green"
                                      : "red"
                                    : "inherit",
                              }}
                            >
                              {column.id === "actions" ? (
                                <div
                                  style={{
                                    display: "flex",
                                    justifyContent: "center",
                                    gap: "8px",
                                  }}
                                >
                                  <IconButton sx={{ color: "black" }}>
                                    <EditIcon
                                      style={{
                                        cursor: "pointer",
                                        fontSize: "18px",
                                      }}
                                      onClick={() =>
                                        navigate(`/manage-admin-edit/${row.id}`)
                                      }
                                    />
                                  </IconButton>
                                  <IconButton
                                    sx={{ color: "black" }}
                                    onClick={() => {
                                      setSelectedAdminId(row.id);
                                      setDeleteModalOpen(true);
                                    }}
                                  >
                                    <DeleteIcon style={{ fontSize: "18px" }} />
                                  </IconButton>
                                  <div
                                    className="form-check form-switch"
                                    style={{ marginTop: "5px" }}
                                  >
                                    <input
                                      type="checkbox"
                                      className="form-check-input"
                                      id={`toggleSwitch-${row.id}`}
                                      checked={row.is_active}
                                      onChange={() => {
                                        setToggleTarget(row);
                                        setToggleModalOpen(true);
                                      }}
                                    />
                                    <label
                                      className="form-check-label"
                                      htmlFor={`toggleSwitch-${row.id}`}
                                    ></label>
                                  </div>
                                </div>
                              ) : value === null ||
                                value === undefined ||
                                value === "" ? (
                                "--"
                              ) : (
                                value
                              )}
                            </TableCell>
                          );
                        })}
                      </TableRow>
                    ))
                ) : (
                  <TableRow>
                    <TableCell
                      colSpan={columns.length}
                      align="center"
                      style={{ padding: "40px 0" }}
                    >
                      No Data Available
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
          <TablePagination
            rowsPerPageOptions={[20, 50, 100, 500, 1000, 2000, 5000]}
            component="div"
            count={filteredData.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </Paper>
      </div>

      {/* Delete Confirmation Modal */}
      <Modal
        open={deleteModalOpen}
        onClose={() => setDeleteModalOpen(false)}
        aria-labelledby="delete-confirmation-title"
        aria-describedby="delete-confirmation-description"
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 550,
            bgcolor: "background.paper",
            borderRadius: 2,
            boxShadow: 24,
            p: 4,
          }}
        >
          <h3 id="delete-confirmation-title">Are you sure?</h3>
          <hr />
          <p id="delete-confirmation-description">
            Do you really want to delete this admin? This action cannot be
            undone.
          </p>
          <hr />
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              gap: "10px",
              marginTop: "20px",
            }}
          >
            <Button
              variant="outlined"
              onClick={() => setDeleteModalOpen(false)}
            >
              No
            </Button>
            <Button variant="contained" color="error" onClick={handleDelete}>
              Yes, Delete
            </Button>
          </div>
        </Box>
      </Modal>

      {/* Toggle Status Modal */}
      {/* Active or InActive Confirmation Modal */}

      <Modal
        open={toggleModalOpen}
        onClose={() => setToggleModalOpen(false)}
        aria-labelledby="toggle-status-title"
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 500,
            bgcolor: "background.paper",
            borderRadius: 2,
            boxShadow: 24,
            p: 4,
          }}
        >
          <h3 id="toggle-status-title">Are you sure?</h3>
          <hr />
          <p>
            Do you want to {toggleTarget?.is_active ? "INACTIVATE" : "ACTIVATE"}{" "}
            this admin?
          </p>
          <hr />
          <div style={{ display: "flex", justifyContent: "flex-end", gap: 10 }}>
            <Button
              onClick={() => setToggleModalOpen(false)}
              variant="outlined"
            >
              Cancel
            </Button>
            <Button
              onClick={handleToggleStatus}
              variant="contained"
              color="primary"
            >
              Confirm
            </Button>
          </div>
        </Box>
      </Modal>
    </>
  );
}
